export class SettingsMenu {

    constructor(sfxManager) {
        this.sfx     = sfxManager;
        this.overlay = document.getElementById('SettingsOverlay');
        this.slider  = document.getElementById('VolumeSlider');
        this.valEl   = document.getElementById('VolumeValue');
        this.closeBtn = document.getElementById('SettingsClose');

        // Set slider to current volume
        if (this.slider) {
            this.slider.value = Math.round((this.sfx?.getVolume() ?? 1) * 100);
            this.updateLabel();

            this.slider.addEventListener('input', () => {
                const vol = parseInt(this.slider.value) / 100;
                this.sfx?.setVolume(vol);
                this.updateLabel();
            });
        }

        this.closeBtn?.addEventListener('click', () => this.hide());

        // Close on overlay background click
        this.overlay?.addEventListener('click', (e) => {
            if (e.target === this.overlay) this.hide();
        });

        const navToggle = document.getElementById('NavBtnToggle');
        let navBtnsEnabled = localStorage.getItem('td_navbtns') !== 'false';

        const applyNavToggle = () => {
            if (!navToggle) return
            navToggle.textContent = navBtnsEnabled ? 'ON' : 'OFF'
            navToggle.classList.toggle('active', navBtnsEnabled)
            // Also update live if already in lobby
            const lobbyNav = document.getElementById('LobbyNav')
            if (lobbyNav && lobbyNav.classList.contains('visible')) {
                if (!navBtnsEnabled) lobbyNav.classList.replace('visible', 'invisible')
            }
        }

        applyNavToggle()
            navToggle?.addEventListener('click', () => {
                navBtnsEnabled = !navBtnsEnabled
                localStorage.setItem('td_navbtns', String(navBtnsEnabled))
                applyNavToggle()
            }
        );
    }

    updateLabel() {
        if (this.valEl && this.slider) {
            this.valEl.textContent = `${this.slider.value}%`;
        }
    }

    show() {
        this.overlay?.classList.replace('invisible', 'visible');
    }

    hide() {
        this.overlay?.classList.replace('visible', 'invisible');
    }

    toggle() {
        if (this.overlay?.classList.contains('visible')) this.hide();
        else this.show();
    }

    
}